var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"face-images"},_vm._l((_vm.dataSource),function(item,index){return _c('BigImg',{key:index,attrs:{"url":item.access_url}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }